export default __webpack_public_path__ + "static/NotoSans-ExtraLight-73c9131923338c4f3cd4164ba02550f6.ttf";